import React, { useCallback } from "react";
import { Select } from "antd";

const { Option } = Select;

const AssigneeSelect = ({ data = [], onSearchUser, value, onChange }: any) => {
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleSearch = useCallback(
    debounce((val) => {
      onSearchUser?.(val?.trim() || "");
    }, 500),
    [onSearchUser]
  );
  return (
    <Select
      showSearch
      placeholder="Search or select assignee"
      filterOption={false}
      onSearch={handleSearch}
      labelInValue
      value={data.length > 0 && value}
      onChange={onChange}
    >
      {data.map((user) => (
        <Option key={user._id} value={user._id}>
          {user.name}
        </Option>
      ))}
    </Select>
  );
};

export default AssigneeSelect;
